export default __webpack_public_path__ + "static/media/book-closure-inprogress.d16d185b.png";